import { Component } from '@angular/core';
import {
    FieldType,
    FormlyExtension,
    FormlyFieldConfig
} from '@ngx-formly/core';
import { sharedMonthDiscount } from '../../form-parts-definition';
import { MonthFlags } from '../month-select/month-select.component';

@Component({
  selector: 'tpa-month-discount',
  templateUrl: './month-discount.component.html',
  // eslint-disable-next-line @angular-eslint/no-host-metadata-property
  host: { class: 'tpa-wrapper__control' },
})
export class MonthDiscountComponent
  extends FieldType
  implements FormlyExtension
{
  defaultOptions = {
    className: 'p-col-12',
    props: {
      translate: true,
      open: true,
    },
  };

  MonthFlags = MonthFlags;

  onPopulate(field: FormlyFieldConfig) {
    if (field.fieldGroup) {
      return;
    }

    field.fieldGroup = [sharedMonthDiscount()];
  }
}
